const TrackEvent = {
  data() {
    return {
      submitTrackEvent: '',
      resetTrackEvent: '',
      previousFormValue: {},
      trackEventByControlName: {},
    };
  },
  computed: {
    userId() {
      return this.$store.state.user.userData?.userId;
    },
    email() {
      return this.$store.state.user.userData?.email;
    },
  },
  methods: {
    trackSubmit(payload) {
      if (this.submitTrackEvent) {
        this.trackEvent(this.submitTrackEvent, payload);
      }
    },
    trackReset() {
      if (this.resetTrackEvent) {
        this.trackEvent(this.resetTrackEvent);
      }
    },
    trackChange(formValue) {
      this.trackValueChange(formValue, this.previousFormValue);
      this.previousFormValue = formValue;
    },
    trackValueChange(formValue, previousFormValue = {}) {
      Object.entries(formValue).forEach(([key, value]) => {
        if (!value) {
          return;
        }
        if (Array.isArray(value) && previousFormValue[key]) {
          const selectedItem = value.find((s) => !previousFormValue[key].includes(s));
          if (selectedItem && this.trackEventByControlName[key]?.select) {
            this.trackEvent(this.trackEventByControlName[key].select, { [key]: value });
            return;
          }
          const unselectedItem = previousFormValue[key].find((s) => !value.includes(s));
          if (unselectedItem && this.trackEventByControlName[key]?.unselect) {
            this.trackEvent(this.trackEventByControlName[key].unselect, { [key]: value });
          }
          return;
        }
        if (typeof value === 'object') {
          this.trackValueChange(value, previousFormValue[key]);
          return;
        }
        if (previousFormValue[key] !== value && this.trackEventByControlName[key]) {
          this.trackEvent(this.trackEventByControlName[key], { [key]: value });
        }
      });
    },
    trackEvent(event, payload = {}) {
      this.$track(event, {
        ...payload,
        userId: this.userId,
        email: this.email,
      });
    },
  },
};

export default TrackEvent;
